import IconHome from "../../../assets/img/icon/ic-side-menu-home.svg";
import IconPromo from "../../../assets/img/icon/ic-side-menu-event-promo.svg";
import IconProduct from "../../../assets/img/icon/ic-side-menu-product.svg";
import IconAboutUs from "../../../assets/img/icon/ic-side-menu-about-us.svg";
import IconContactUs from "../../../assets/img/icon/ic-side-menu-contact-us.svg";
import IconFaq from "../../../assets/img/icon/ic-side-menu-faq.svg";


export const SidebarData = [
    {
        tittle:'Beranda',
        path:'/',
        img: IconHome
    },
    {
        tittle:'Media Informasi',
        path:'/media-informasi',
        img: IconPromo
    },
    {
        tittle:'Produk Pinjaman',
        path:'/#product-section',
        img: IconProduct
    },
    {
        tittle:'Tentang Kami',
        path:'/tentang-kami',
        img: IconAboutUs
    },
    {
        tittle:'Hubungi Kami',
        path:'/hubungi-kami',
        img: IconContactUs
    },
    {
        tittle:'FAQ',
        path:'/faq',
        img: IconFaq
    },
]